import { useEffect, useState } from "react";
import { supplyChainTabs, tabsTypes } from "../../conig";

import MateriallFlow from "../material-flow";
import AdditionalSubjects from "../additional-subjects";
import InformationSources from "../information-sources";

export default function SupplyChain({
  onChange = () => { },
  formValue = {},
  t = (s) => s,
  sources = [],
  activeKey,
  id,
  focusParticipant,
  setDisabledFooter = () => { },
}) {
  const [showInfoSources, setShowInfoSources] = useState(false);
  const [showAdditionalSubjects, setShowAdditionalSubjects] = useState(false);

  useEffect(() => {
    if (activeKey === supplyChainTabs[1].key && !showAdditionalSubjects) {
      setShowAdditionalSubjects(true);
    }
    if (activeKey === supplyChainTabs[2].key && !showInfoSources) {
      setShowInfoSources(true);
    }
  }, [activeKey]);

  return (
    <div>
      <div style={{ display: activeKey === supplyChainTabs[0].key ? 'block' : 'none' }}>
        <MateriallFlow
          onChange={onChange}
          formValue={formValue}
          id={id}
          t={t}
          visible={activeKey === supplyChainTabs[0].key}
          focusParticipant={focusParticipant}
          setDisabledFooter={setDisabledFooter}
        />
      </div>

      {showAdditionalSubjects && (
        <div style={{ display: activeKey === supplyChainTabs[1].key ? 'block' : 'none' }}>
          <AdditionalSubjects
            formValue={formValue}
            t={t}
            onChange={onChange}
            section={tabsTypes.SUPPLY_CHAIN}
            visible={activeKey === supplyChainTabs[1].key}
          />
        </div>
      )}

      {showInfoSources && (
        <div style={{ display: activeKey === supplyChainTabs[2].key ? 'block' : 'none' }}>
          <InformationSources
            onChange={onChange}
            formValue={formValue}
            t={t}
            section={tabsTypes.SUPPLY_CHAIN}
            data={sources}
            visible={activeKey === supplyChainTabs[2].key}
          />
        </div>
      )}
    </div>
  );
}
